import { archivoFont, firaCodeFont, spaceGroteskFont } from 'styles/fonts';

const colors = {
  gradients: {
    loading: 'linear-gradient(90deg, #9AB0FF, #3763FF, #2525D7)',
    primary: 'linear-gradient(64.26deg, #2525D7 22.07%, #3763FF 84.47%)',
    flat: 'linear-gradient(90deg, #3763FF, #3763FF)',
    background: 'linear-gradient(90deg, #DCEAFD, #F5FEFF, #F5FEFF, #F1EDFE)',
    special: 'linear-gradient(68.66deg, #FDDEF8 0%, #E3E2FF 34.38%, #E4FFFF 70.31%, #FFFFFF 100%)',
  },
  primary: {
    main: '#3763FF',
    lighter: '#D3DDFF',
    lightest: '#F0F4FF',
    lightestMore: '#F6F8FD',
    dark: '#2525D7',
    light: '#4D74FF',
  },
  secondary: {
    yellow: '#EFAC26',
    red: '#F3683C',
    brick: '#BC6038',
    paleRed: '#FFF8F5',
    green: '#29A964',
  },
  functional: {
    white: '#FFFFFF',
    gray2: '#FCFCFC',
    gray3: '#F2F2F2',
    gray4: '#EAEAEA',
    gray5: '#B0B0B0',
    gray6: '#8C8C8C',
    darkGray: '#8C8C8C',
    gray7: '#434343',
    gray8: '#363636',
    darkestGray: '#363636',
    black: '#000000',
  },
};

const fonts = {
  archivo: archivoFont.style.fontFamily,
  spaceGrotesk: spaceGroteskFont.style.fontFamily,
  mono: firaCodeFont.style.fontFamily,
};

const container = {
  sm: '304px',
  md: '624px',
  lg: '1224px',
};

const breakPoints = {
  sm: '310px',
  md: '672px',
  lg: '1400px',
};

const navBreakPoints = {
  sm: breakPoints.sm,
  md: '510px',
  lg: '1126px',
};

const borderRadius = {
  sm: '0.4rem',
  main: '1.2rem',
  full: '9999px',
  circle: '50%',
};

// Todo: Determine the standard spacing on the platform

const spacing = {
  sm: '0.5rem',
  md: '1rem',
  lg: '1.5rem',
  xl: '24px',
};

const boxShadow = {
  black: '0 12px 24px 0 rgba(54, 54, 54, 0.12)',
  blue: '0px 12px 24px 0px rgba(51, 82, 192, 0.12)',
  red: '0px 12px 24px 0px rgba(243, 104, 60, 0.12)',
};

const zIndex = {
  backdrop: 9,
};

export const archimedesTheme = {
  colors,
  fonts,
  borderRadius,
  container,
  breakPoints,
  navBreakPoints,
  spacing,
  boxShadow,
  zIndex,
};
